import React from 'react';
import SKILL_STATUS from '../../constants/skill-status.json';
import SubjectIcon from '../subjects/icon';
import getAssignmentCourseId from '../../utilities/assignments/get-course-id';
import getAssignmentCourseName from '../../utilities/assignments/get-course-name';
import getItemData from './get-item-data';

export default function mapAssignmentsToNavListItems(assignments) {
  return assignments
    ?.reduce((groupedAssignments, assignment) => {
      const assignmentUnfinished = SKILL_STATUS.groupings.unfinished.includes(assignment.status);

      let foundAssignmentGroup = groupedAssignments.find((groupedAssignment) =>
        [
          assignment.course?.course_id,
          `${assignment.tutor_id}-${assignment.skill.subject_id}`,
        ].includes(groupedAssignment.courseId)
      );

      if (!foundAssignmentGroup) {
        groupedAssignments.push({
          courseId: getAssignmentCourseId(assignment),
          courseName: getAssignmentCourseName(assignment),
          count: assignmentUnfinished ? 1 : 0,
        });
      } else if (assignmentUnfinished) {
        foundAssignmentGroup.count++;
      }

      return [...groupedAssignments];
    }, [])
    .map(({ courseId, courseName, count }) =>
      getItemData({
        exact: false,
        graphic: count ? (
          <div className="number-badge">{count}</div>
        ) : (
          <SubjectIcon subjectName={courseName} />
        ),
        primaryText: courseName,
        to: `/assignments/${courseId}`,
      })
    );
}
